import React, { useEffect, useState } from "react";

import { Dropdown } from "react-bootstrap";
import MainPagetitle from "../../../../layouts/MainPagetitle";
import LeadsModal from "./LeadsModal";
import LeadsSearch from "./LeadsSearch/LeadsSearch";

const Leads = (props) => {
  const { role } = props?.$store?.user || {};
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
    orderBy: "updatedAt",
    orderDirection: "DESC",
  });
  const [totalPageChange, setTotalPageChange] = useState({
    page: 1,
    limit: 10,
    orderBy: "updatedAt",
    orderDirection: "DESC",
  });

  const [tableData, setTableData] = useState([]);
  const [logsData, setLogsData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });
  const [modalFields, setModalFields] = useState([
    {
      label: "Name",
      name: "name",
      type: "text",
      placeholder: "Please Enter",
    },
    {
      label: "Mobile No.",
      name: "mobileNo",
      type: "text",
      placeholder: "Please Enter",
      onChange: (value) => handleMobileNo(value),
      required: true,
    },
    {
      label: "Email ID",
      name: "emailAddress",
      type: "email",
      placeholder: "Please Enter",
      onChange: (value) => handleEmailId(value),
      required: true,
    },
    {
      label: "Requirement",
      name: "requirement",
      type: "select",
      options: _enum.SALES_REQUIREMENTS,
      placeholder: "Please Enter",
    },
    {
      label: "Lead Status",
      name: "status",
      type: "select",
      options: _enum.SALES_ENQUIRY_STATUS,
      placeholder: "Please Enter",
      required: true,
    },
    {
      label: "Remarks",
      name: "remarks",
      type: "textarea",
    },
  ]);
  const [editData, setEditData] = useState([]);
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupfields, setPopupfields] = useState({});
  const [popupdata, setPopupdata] = useState({});

  // ----------------------------------------------------------------
  const [rowcount, setRowcount] = useState(0);
  const [columns, setColumns] = useState([
    {
      dataIndex: "name",
      title: "Name",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    {
      dataIndex: "mobileNo",
      title: "Mobile No.",
    },
    {
      dataIndex: "requirement",
      title: "Requirement",
      render: (text, record) => {
        return <>{text || "-"}</>;
      },
    },
    {
      dataIndex: "email",
      title: "Email ID",
      render: (text, record) => {
        return <>{text || "-"}</>;
      },
    },
    {
      dataIndex: "createdAt",
      title: "Generated On",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        if (record?.createdAt) {
          return date;
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "status",
      title: "Lead Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.status?.toLowerCase()] || "";

        let dropdowItems;
        let { role } = props?.$store?.user || {};
        if (role === _enum.ROUTE_PERSONAS.ops) {
          dropdowItems = _enum?.OPS_LEADS_STATUS?.filter(
            (v) => v.key !== "open"
          );
        } else {
          dropdowItems = _enum?.ADMIN_LEADS_STATUS?.filter(
            (v) => v.key !== "open"
          );
        }
        return (
          <Dropdown
            className={Object.className({
              "status-dropdown": true,
              "no-arrow pe-none": true,
            })}
          >
            <Dropdown.Toggle as="div" className={`${mappedStatus}`}>
              <span>{record?.status?.toTitleCase() || "-"}</span>
              <i class="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
    {
      dataIndex: "remarks",
      title: "Remarks",
      render: (text, record) => {
        return <>{text || "-"}</>;
      },
    },
  ]);

  const onPageChange = (pageData) => {
    console.log({ onPageChange: pageData });
    setTotalPageChange({
      ...search,
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };

  const openModal = () => {
    setOpenCanvas(true);
  };

  const closeModal = () => {
    setOpenCanvas(false);
  };

  // VALIDATIONS

  const handleMobileNo = (e) => {
    const numberReg = _enum?.REGEX?.number;
    const fieldValue = e.target.value;
    if (numberReg.test(fieldValue) && fieldValue.length === 10) {
      setErrorMessage("");
    } else {
      setErrorMessage({
        name: "mobileNo",
        message: "Please enter a valid Mobile Number",
      });
    }
  };

  const handleEmailId = (e) => {
    const emailReg = _enum?.REGEX?.email;
    const fieldValue = e.target.value;
    if (emailReg.test(fieldValue)) {
      setErrorMessage("");
    } else {
      setErrorMessage({
        name: "emailAddress",
        message: "Please enter a valid Email Address",
      });
    }
  };

  const getEnquiries = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, [
        "limit",
        "orderBy",
        "orderDirection",
        "page",
      ]);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
      console.log({ defaultSearchData: payload });
    } else {
      payload = {
        ...search,
        ...params,
      };
    }

    props.apis.apiGetEnquiries(payload).then(({ data, total }) => {
      setTableData(data);
      setIsFetching(false);
      setRowcount(total);
    });
  };

  const viewEnquiry = (record) => {
    setEditmode(false);
    setViewmode(true);

    props.apis
      .apiGetEnquiriesById({ enquiryId: record.enquiryId })
      .then((data) => {
        console.log({ apiGetEnquiriesById: data, record });
        let filteredData = Object.only(
          data,
          modalFields.map((v) => v.name)
        );

        let sortedData = {
          name: filteredData?.name,
          mobileNo: filteredData?.mobileNo,
          emailAddress: filteredData?.emailAddress,
          requirement: filteredData?.requirement,
          status: filteredData?.status,
          remarks: filteredData?.remarks,
        };

        setPopupdata(sortedData);
        setEditData(data);
        openModal();
      });
  };

  const editEnquiry = (record) => {
    setEditmode(true);
    setViewmode(false);
    console.log({ record });

    props.apis
      .apiGetEnquiriesById({ enquiryId: record.enquiryId })
      .then((data) => {
        console.log({ apiGetEnquiriesById: data });
        let filteredData = Object.only(
          data,
          modalFields.map((v) => v.name)
        );

        let sortedData = {
          name: filteredData?.name,
          mobileNo: filteredData?.mobileNo,
          emailAddress: filteredData?.emailAddress,
          requirement: filteredData?.requirement,
          status: filteredData?.status,
          remarks: filteredData?.remarks,
        };

        setPopupdata(sortedData);
        setEditData(data);
        openModal();
      });
  };

  const handleSubmit = (e, data, form) => {
    e.preventDefault();
    console.log("formdata: ", data, editData);
    let formdata = data;
    let payload = {
      status: formdata.status,
    };
    if (editmode) {
      props.apis
        .apiUpdateEnquiry(payload, {
          enquiryId: editData?.enquiryId,
        })
        .then((res) => {
          console.log({ apiUpdateEnquiry: res });
          swal2.fire({
            title: "Enquiry updated successfully.",
            icon: "success",
            iconColor: "#805DCD",
            timer: 4000,
          });
          onModalClose();
          getEnquiries();
        });
    } else {
      if (data?.status === "") {
        swal2.fire({
          title: "Please fill the required fields",
          icon: "error",
          iconColor: "#FF4D4D",
          timer: 4000,
        });
      } else {
        // props.apis.apiAddLead(payload).then((res) => {
        //   console.log({ apiAddLead: res });
        //   swal2.fire({
        //     title: "Lead added successfully.",
        //     icon: "success",
        //     iconColor: "#234C9B",
        //     timer: 4000,
        //   });
        //   closeModal();
        //   getEnquiries();
        // });
      }
    }
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on leads", data, reset);
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getEnquiries();
    } else {
      setSearch({
        ...data,
        ...search,
      });
      getEnquiries(data, reset);
    }
  };

  const addModalFields = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setLogsData([]);
    let filteredFields = modalFields.exclude(["loanAmount"], "name");

    let statusfield = modalFields.find((o) => o.name == "status");
    statusfield.label = "Lead Status";

    let fields = (filteredFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    console.log("formdata: ", fields, formdata);

    setModalFields([...filteredFields]);
    setPopupfields(fields);
    setPopupdata(formdata);
    setOpenCanvas(true);
  };

  const onModalClose = () => {
    console.log("onModalClose");
    closeModal();
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
  };

  useEffect(() => {
    // console.log(search);
    getEnquiries(totalPageChange);
  }, [totalPageChange]);

  useEffect(() => {
    let fields = (modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );

    console.log({ updatedfields: fields });

    setPopupfields(fields);
  }, [editData]);

  props.$setNode({
    props,
  });
  return (
    <>
      <MainPagetitle
        mainTitle={`${
          role === _enum.ROUTE_PERSONAS.ops ? "Assigned Leads" : "Leads"
        }`}
        pageTitle={"Leads"}
        parentTitle={"Home"}
        pageIcon={imagepaths.LeadsIcon}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="tbl-caption-container leads_wrapper">
                  <LeadsSearch
                    onSearch={(...arg) => onSearch(...arg)}
                    // addModalFields={addModalFields}
                  />
                </div>
                <AppTable
                  data={tableData}
                  columns={columns}
                  onChange={(...arg) => onPageChange(...arg)}
                  total={rowcount}
                  reorder={true}
                  viewAction={(...args) => viewEnquiry(...args)}
                  editAction={(...args) => editEnquiry(...args)}
                  deletable={false}
                  loading={isFetching}
                ></AppTable>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LeadsModal
        id="leadsCanvas"
        title={`${
          editmode ? "Edit Lead" : viewmode ? "View Lead" : "Add Lead"
        }`}
        show={openCanvas}
        onClose={() => onModalClose()}
        data={popupdata}
        editdata={editData}
        fields={popupfields}
        editmode={editmode}
        viewmode={viewmode}
        logsData={logsData}
        noValidate={true}
        onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? "Update" : "Submit"}`}
        disableallfields={viewmode ? true : false}
        errorMessage={errorMessage}
        disablefields={[
          "name",
          "mobileNo",
          "emailAddress",
          "requirement",
          "remarks",
        ]}
      />
    </>
  );
};

export default constore(Leads);
